export const noEventTypesText = "No event types have been set up yet.";

export const addEventTypesLinkText = "Add event types in Agency settings";

const settingsLocation = "under Agency settings, Activity types.";

const joinNames = (names: string[]): string => {
    if (names.length === 1) {
        return names[0];
    }
    if (names.length === 2) {
        return `${names[0]} or ${names[1]}`;
    }
    return `${names.slice(0, -1).join(", ")}, or ${names[names.length - 1]}`;
};

export const askAdministratorText = (administratorNames: string[]): string => {
    const who =
        administratorNames.length === 0
            ? "an administrator"
            : joinNames(administratorNames);
    return `Ask ${who} to add them ${settingsLocation}`;
};
